import { FormattedMessage } from 'react-intl';
import { Grid, Typography, Stack } from 'components/ui';
import { GrayCard } from 'components/styles_components/card';
import { CardOptionTypography, CardOptionHintTypography } from 'components/styles_components/typography';
import { userLabel } from 'utils/user';

const InspectorCard = ({ inspector }) => (
  <Grid size={{ xs: 6, lg: 3 }}>
    <GrayCard>
      <Stack>
        <CardOptionTypography>
          <FormattedMessage id="inspector" />
        </CardOptionTypography>
        <Typography component="span">{userLabel(inspector)}</Typography>
        <CardOptionHintTypography>
          {inspector?.email}
        </CardOptionHintTypography>
      </Stack>
    </GrayCard>
  </Grid>
);

export default InspectorCard;
